<div class="cover-photo-container">
    <img decoding="async" src="/assets/srec-cover-photo-cropped.png" class="cover-photo"
        alt="Spruce-SREC-Cover-Photo" />
</div>
<div class="page-container">
    <div class="inner-page-container">
        <div class="srec-prereq-container">
            <div *ngIf="!showMainForm && !failSection" class="srec-prereq">
                <div *ngIf="!showForm" class="owner-question-container">
                    <span class="owner-question">Do you own the solar system on your property?</span>
                    <div>
                        <!-- TODO: update toggle button values to boolean -->
                        <mat-button-toggle-group [formControl]="isOwnerControl" aria-label="System Owner?"
                            [hideSingleSelectionIndicator]="true">
                            <mat-button-toggle value="yes">Yes</mat-button-toggle>
                            <mat-button-toggle value="no">No</mat-button-toggle>
                        </mat-button-toggle-group>
                    </div>
                </div>

                <div class="option-container">
                    <span class="referral-question">What is your property type?</span>
                    <mat-form-field appearance="fill" class="property-type-question">
                        <mat-label>Property Type</mat-label>
                        <mat-select id="propertyType" [formControl]="propertyType">
                            <mat-option value="Residential" matTooltip="Residential - Homeowner">
                                Residential - Homeowner
                            </mat-option>
                            <mat-option value="Commercial / Industrial" matTooltip="Commercial / Industrial">
                                Commercial / Industrial
                            </mat-option>
                            <mat-option value="Other" matTooltip="Other - Non-profits, etc..">
                                Other - Non-profits, etc..
                            </mat-option>
                            <mat-option value="Spruce Existing Partner" matTooltip="Spruce Existing Partner">
                                Spruce Existing Partner
                            </mat-option>
                        </mat-select>
                        <mat-error *ngIf="propertyType.invalid && (propertyType.touched || showErrors)">
                            Please select a property type before continuing
                        </mat-error>
                    </mat-form-field>
                </div>

                <div class="owner-question-container"
                    *ngIf="propertyType.value === 'Commercial / Industrial' || propertyType.value === 'Other'">
                    <span class="owner-question">Are you an existing installer partner of Spruce?</span>
                    <div>
                        <mat-button-toggle-group [formControl]="isinstallerControl" aria-label="Existing Installer?"
                            [hideSingleSelectionIndicator]="true">
                            <mat-button-toggle value="yes">Yes</mat-button-toggle>
                            <mat-button-toggle value="no">No</mat-button-toggle>
                        </mat-button-toggle-group>
                    </div>
                </div>

                <div class="option-container">
                    <span class="referral-question">Who is your referral?</span>
                    <mat-form-field appearance="fill">
                        <mat-label>Referral Source</mat-label>
                        <mat-select id="referralSource" [formControl]="referralSource">
                            <mat-option value="Internet Search">Internet Search</mat-option>
                            <mat-option value="Other">Other</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>

                <div class="option-container">
                    <button class="button" mat-flat-button (click)="back()">
                        Back
                    </button>
                    <button class="button" mat-flat-button [disabled]="
                            referralSource.value === null ||
                            !isOwnerControl.value
                        " (click)="onNext()">
                        Next
                    </button>
                </div>
            </div>
        </div>

        <button class="form-back-button" mat-icon-button type="button" *ngIf="showMainForm"
            (click)="returnToRegisterSection()">
            <mat-icon>arrow_back</mat-icon>
        </button>

        <div id="form-section">
            <form-home-marketing-desk [showForm]="showMainForm" [referralSource]="referralSource.value"
                [isExistingInstaller]="isinstallerControl.value === 'yes'"></form-home-marketing-desk>
        </div>
        <div *ngIf="failSection" class="fail-case-container">
            <span class="fail-case-text">Sorry, you are not eligible for this program.</span>
            <div class="ineligible-form-container">
                <p class="ineligible-form-text">Please provide your contact information and we'll reach out to discuss
                    alternative options.</p>
                <form [formGroup]="ineligibleForm" (ngSubmit)="submitIneligibleForm()" class="ineligible-form">
                    <mat-form-field appearance="fill">
                        <mat-label>Full Name</mat-label>
                        <input matInput formControlName="fullName" required>
                        <mat-error
                            *ngIf="ineligibleForm.get('fullName')?.invalid && ineligibleForm.get('fullName')?.touched">
                            Full Name is required
                        </mat-error>
                    </mat-form-field>

                    <mat-form-field appearance="fill">
                        <mat-label>Email</mat-label>
                        <input matInput type="email" formControlName="email" required>
                        <mat-error *ngIf="ineligibleForm.get('email')?.invalid && ineligibleForm.get('email')?.touched">
                            Please enter a valid email address
                        </mat-error>
                    </mat-form-field>

                    <mat-form-field appearance="fill">
                        <mat-label>Phone Number</mat-label>
                        <input matInput formControlName="phoneNumber" required maxlength="10" mask="(000) 000-0000">
                        <mat-error
                            *ngIf="ineligibleForm.get('phoneNumber')?.invalid && ineligibleForm.get('phoneNumber')?.touched">
                            Valid Phone Number is required
                        </mat-error>
                    </mat-form-field>

                    <mat-form-field appearance="fill">
                        <mat-label>Street Address</mat-label>
                        <input matInput formControlName="streetAddress" required>
                        <mat-error
                            *ngIf="ineligibleForm.get('streetAddress')?.invalid && ineligibleForm.get('streetAddress')?.touched">
                            Street Address is required
                        </mat-error>
                    </mat-form-field>

                    <mat-form-field appearance="fill">
                        <mat-label>City</mat-label>
                        <input matInput formControlName="city" required>
                        <mat-error *ngIf="ineligibleForm.get('city')?.invalid && ineligibleForm.get('city')?.touched">
                            City is required
                        </mat-error>
                    </mat-form-field>

                    <mat-form-field appearance="fill">
                        <mat-label>State</mat-label>
                        <input matInput formControlName="state" required>
                        <mat-error *ngIf="ineligibleForm.get('state')?.invalid && ineligibleForm.get('state')?.touched">
                            State is required
                        </mat-error>
                    </mat-form-field>

                    <mat-form-field appearance="fill">
                        <mat-label>Zipcode</mat-label>
                        <input matInput formControlName="zipcode" required maxlength="5" pattern="[0-9]{5}">
                        <mat-error
                            *ngIf="ineligibleForm.get('zipcode')?.invalid && ineligibleForm.get('zipcode')?.touched">
                            Valid Zipcode is required
                        </mat-error>
                    </mat-form-field>

                    <div class="contract-upload-section">
                        <p class="contract-upload-label">Upload Current PPA/Lease Contract (Optional)</p>
                        <p class="contract-upload-description">Please upload your current Power Purchase Agreement (PPA)
                            or Lease contract to help us better understand your situation.</p>
                        <div class="upload-container">
                            <input type="file" class="file-input" accept=".pdf,.doc,.docx"
                                formControlName="contractFile" (change)="onContractFileChange($event)"
                                #contractFileUpload hidden />
                            <span class="upload-status">
                                {{ contractFileName || 'No contract uploaded yet' }}
                            </span>
                            <button mat-icon-button type="button" class="upload-btn"
                                (click)="contractFileUpload.click()">
                                <mat-icon>attach_file</mat-icon>
                            </button>
                        </div>
                    </div>

                    <div class="button-container">
                        <button type="button" class="button" mat-flat-button (click)="back()">
                            Return to Home
                        </button>
                        <button type="submit" class="button" mat-flat-button color="primary"
                            [disabled]="ineligibleForm.invalid || isSubmitting">
                            Submit
                        </button>
                    </div>

                    <div *ngIf="submitError" class="error-message">
                        {{ submitError }}
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>